import React, { useContext, useState } from "react";
import { UserContext, BaseUrl } from "../../App.js";
import "./Settings.css";
import Form from "./../../UI/Form/Form";

function ChangeUserPwd(props) {
  const [user] = useContext(UserContext);
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const { logOutCallback } = props;

  const handleSubmit = async (event) => {
    event.preventDefault();
    const result = await (
      await fetch(`${BaseUrl}/user/password`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.accesstoken}`,
        },
        body: JSON.stringify({
          old_password: oldPwd,
          new_password: newPwd,
        }),
      })
    ).json();
    if (result.status === "success") logOutCallback();
    else console.log(result.error);
  };

  const handleInput = (event) => {
    if (event.target.name === "old password") {
      setOldPwd(event.target.value);
    } else setNewPwd(event.target.value);
  };
  return (
    <Form
      firstInputId="change-user-password-input"
      firstInputType="password"
      firstInputLabel="old password"
      firstInputPlaceHolder="*******"
      firstInputValue={oldPwd}
      secondInputPlaceHolder="******"
      secondInputType="password"
      secondInputLabel="New Password"
      secondInputValue={newPwd}
      buttonType="submit"
      formTitle="Change User Password"
      onNewPasswordInputChange={handleInput}
      onOldPasswordInputChange={handleInput}
      handleSubmit={handleSubmit}
    />
  );
}

export default ChangeUserPwd;
